import React, { useState } from 'react';
import type { LabelMeta } from '../../../types/scanV2';

export interface BrandNameFormProps {
  side: 'a' | 'b';
  onSubmit: (meta: LabelMeta) => void;
  onCancel: () => void;
  /** Values given earlier in this label session. */
  initial?: LabelMeta;
}

/** Asked when the server needs a brand and a product name (brand_name_required). */
export default function BrandNameForm({ side, onSubmit, onCancel, initial }: BrandNameFormProps) {
  const [brand, setBrand] = useState(initial?.brand ?? '');
  const [name, setName] = useState(initial?.name ?? '');
  const [variant, setVariant] = useState(initial?.variant ?? '');
  const ready = brand.trim() !== '' && name.trim() !== '';
  const field = (id: string, label: string, value: string, set: (v: string) => void) => (
    <div className="stack-1">
      <label htmlFor={`${id}-${side}`} className="t-small" style={{ fontWeight: 600 }}>{label}</label>
      <input
        id={`${id}-${side}`}
        value={value}
        maxLength={120}
        onChange={(event) => { set(event.target.value); }}
        className="compare-barcode-field__input"
      />
    </div>
  );
  return (
    <form
      className="stack-3"
      data-testid="brand-name-form"
      onSubmit={(event) => {
        event.preventDefault();
        if (!ready) return;
        onSubmit({ brand: brand.trim(), name: name.trim(), ...(variant.trim() ? { variant: variant.trim() } : {}) });
      }}
    >
      <p className="t-small t-mute" style={{ margin: 0 }}>Tell us which product this is.</p>
      {field('side-brand', 'Brand', brand, setBrand)}
      {field('side-name', 'Product name', name, setName)}
      {field('side-variant', 'Variant (optional)', variant, setVariant)}
      <div className="flex gap-2">
        <button type="submit" className="btn btn--primary btn--sm" disabled={!ready}>Continue</button>
        <button type="button" className="btn btn--ghost btn--sm" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
